import { render, staticRenderFns } from "./CanvasAreaZoomControls.vue?vue&type=template&id=7b31f346&scoped=true&"
import script from "./CanvasAreaZoomControls.vue?vue&type=script&lang=js&"
export * from "./CanvasAreaZoomControls.vue?vue&type=script&lang=js&"
import style0 from "./CanvasAreaZoomControls.vue?vue&type=style&index=0&id=7b31f346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b31f346",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b31f346')) {
      api.createRecord('7b31f346', component.options)
    } else {
      api.reload('7b31f346', component.options)
    }
    module.hot.accept("./CanvasAreaZoomControls.vue?vue&type=template&id=7b31f346&scoped=true&", function () {
      api.rerender('7b31f346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/CanvasAreaZoomControls.vue"
export default component.exports